import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../contexts/I18nContext";

export default function Signup() {
  const { t } = useI18n();
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ full_name: "", email: "", password: "", firm_name: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success(t("common.success"));
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("common.error"));
    } finally {
      setLoading(false);
    }
  };

  const input = (key, type = "text", testid, required = true, minLen) => (
    <div>
      <label className="kicker !text-slate-500 block mb-2">{t(`auth.${key}`)}</label>
      <input
        type={type}
        required={required}
        minLength={minLen}
        value={form[key === "fullName" ? "full_name" : key === "firm" ? "firm_name" : key] || ""}
        onChange={(e) => setForm({
          ...form,
          [key === "fullName" ? "full_name" : key === "firm" ? "firm_name" : key]: e.target.value,
        })}
        className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 focus:border-[#0A192F] focus:ring-1 focus:ring-[#0A192F] outline-none transition"
        data-testid={testid}
      />
    </div>
  );

  return (
    <>
      <Navbar />
      <main className="min-h-[calc(100vh-64px)] flex items-center justify-center bg-[#FAFAFA] px-6 py-10">
        <div className="w-full max-w-md card-premium p-10">
          <div className="kicker">Dikigoros.io</div>
          <h1 className="mt-3 font-display font-bold text-3xl text-slate-900">{t("auth.signupTitle")}</h1>
          <p className="mt-2 text-slate-600 text-sm">{t("auth.signupSub")}</p>
          <form onSubmit={onSubmit} className="mt-8 space-y-5">
            {input("fullName", "text", "signup-name")}
            {input("email", "email", "signup-email")}
            {input("firm", "text", "signup-firm", false)}
            {input("password", "password", "signup-password", true, 8)}
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full rounded-full px-6 py-3 font-semibold disabled:opacity-60"
              data-testid="signup-submit"
            >
              {loading ? t("common.loading") : t("auth.create")}
            </button>
          </form>
          <div className="mt-5 text-sm text-slate-500">
            {t("auth.hasAccount")} <Link to="/login" className="text-[#0A192F] font-medium hover:underline" data-testid="signup-login-link">{t("auth.loginHere")}</Link>
          </div>
        </div>
      </main>
    </>
  );
}
